import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";

const THEMES = [
  { id:"eternal",     label:"Eternal",     sub:"Cinematic · Gold Particles",   palette:["#0C0B09","#1A1610","#C9A84C"], dark:true  },
  { id:"serenity",    label:"Serenity",    sub:"Editorial · Magazine",          palette:["#060D08","#0D1F10","#7A9E7E"], dark:true  },
  { id:"amour",       label:"Amour",       sub:"Polaroid · Film Vintage",       palette:["#120608","#1A0C0A","#C97B6F"], dark:true  },
  { id:"twilight",    label:"Twilight",    sub:"Asymmetric · Modern",           palette:["#08070F","#130F20","#9B87B8"], dark:true  },
  { id:"ivory",       label:"Ivory",       sub:"Classical · Symmetric",         palette:["#F5F0E8","#EDE5D8","#8B6F47"], dark:false },
  { id:"bloom",       label:"Bloom",       sub:"Minimalist · Single Column",    palette:["#FAFAF7","#F2F5EF","#7A9E7E"], dark:false },
  { id:"priyayi",     label:"Priyayi",     sub:"Adat Jawa · Keraton",           palette:["#1A1105","#0E0A04","#C9A84C"], dark:true,  adat:true },
  { id:"pasundan",    label:"Pasundan",    sub:"Adat Sunda · Taman Hijau",      palette:["#F7F5EE","#EFF5EE","#5A7A56"], dark:false, adat:true },
  { id:"minangkabau", label:"Minangkabau", sub:"Adat Minang · Rumah Gadang",    palette:["#0F0505","#180A08","#B43C28"], dark:true,  adat:true },
];

const FEATURES = [
  { icon:"🔗", title:"Link Personal",      desc:"Setiap tamu dapat link dengan namanya sendiri",         price:"Rp 20rb" },
  { icon:"📊", title:"Pantau RSVP",         desc:"Dashboard realtime untuk monitor kehadiran tamu",       price:"Rp 15rb" },
  { icon:"🖼️", title:"Galeri Foto",         desc:"Upload hingga 8 foto kenangan di undangan",             price:"Rp 15rb" },
  { icon:"💌", title:"Amplop Digital",      desc:"Rekening bank langsung di undangan, mudah disalin",     price:"Rp 10rb" },
  { icon:"🎵", title:"Musik Undangan",      desc:"Upload musik latar yang menemani tamu membaca undangan", price:"Rp 10rb" },
  { icon:"📺", title:"Live Streaming",      desc:"Tampilkan slot live streaming langsung di undangan",     price:"Rp 15rb" },
  { icon:"✅", title:"QR Check-in",         desc:"Absensi tamu dengan scan QR di hari pernikahan",        price:"Rp 20rb" },
  { icon:"♾️", title:"Masa Aktif Selamanya",desc:"Undangan tersimpan selamanya, bukan cuma setahun",     price:"Rp 30rb" },
  { icon:"🌐", title:"Custom Subdomain",    desc:"namakalian.mykisah.id — lebih personal dan mudah ingat",price:"Rp 25rb" },
  { icon:"📥", title:"Export Excel",        desc:"Download daftar tamu dan status RSVP kapan saja",       price:"Rp 10rb" },
];

const PACKAGES = [
  {
    id:null,       name:"À la Carte", price:49000,  color:"rgba(240,232,216,.55)",
    desc:"Semua fitur standar. Tambah add-on sesuai kebutuhan.",
    includes:["RSVP","Buku Tamu","Countdown","Detail Acara","QR Maps","Dress Code","Love Story"],
    cta:"Pesan Sekarang",
  },
  {
    id:"kisah",    name:"Kisah",    price:59000,  color:"#7A9E7E",
    desc:"Lengkap dengan galeri foto dan amplop digital.",
    includes:["Semua fitur base","Galeri Foto (8 foto)","Amplop Digital"],
    cta:"Pilih Kisah",
  },
  {
    id:"istimewa", name:"Istimewa", price:99000,  color:"#C9A84C", popular:true,
    desc:"Paket terlengkap untuk pengalaman undangan premium.",
    includes:["Semua fitur base","Galeri Foto","Amplop Digital","Link Personal","Pantau RSVP","Notif Email"],
    cta:"Pilih Istimewa",
  },
  {
    id:"mahligai", name:"Mahligai", price:149000, color:"#9B87B8",
    desc:"Semua add-on tanpa terkecuali.",
    includes:["Semua fitur base","Semua add-on aktif","Musik Undangan","Live Streaming","Prioritas pengerjaan"],
    cta:"Pilih Mahligai",
  },
];

const FAQS = [
  { q:"Berapa lama undangan selesai dibuat?",
    a:"1×24 jam kerja setelah pembayaran dikonfirmasi. Kami akan menghubungi kamu via WhatsApp setelah selesai." },
  { q:"Bagaimana cara mendapatkan link undangan?",
    a:"Setelah undangan aktif, link akan dikirim langsung ke WhatsApp kamu. Kamu juga bisa cek kapan saja di halaman /cek-order." },
  { q:"Apakah bisa request revisi?",
    a:"Bisa, 1x revisi gratis dalam 3 hari setelah undangan aktif. Revisi tambahan bisa didiskusikan." },
  { q:"Berapa lama masa aktif undangan?",
    a:"Default 1 tahun. Bisa diperpanjang atau beli add-on Masa Aktif Selamanya seharga Rp 30.000." },
  { q:"Apakah bisa ganti tema setelah pesan?",
    a:"Bisa, dengan biaya tambahan Rp 25.000 dan pengerjaan ulang 1×24 jam." },
  { q:"Bagaimana cara share undangan ke tamu?",
    a:"Kamu cukup bagikan link undangan via WhatsApp, Instagram, atau media sosial lainnya. Kalau beli add-on Link Personal, setiap tamu dapat link dengan namanya sendiri." },
  { q:"Apakah bisa menambahkan musik latar?",
    a:"Ya! Dengan add-on Musik Undangan, kamu bisa upload file musik atau link yang akan diputar saat tamu membuka undangan." },
];

const STEPS = [
  { num:"01", title:"Pilih Tema & Paket",  desc:"Browsing 9 tema, pilih sesuai selera. Tambah add-on sesuai kebutuhan." },
  { num:"02", title:"Isi Data & Transfer", desc:"Isi nama pengantin dan data pernikahan, lalu transfer sesuai total tagihan." },
  { num:"03", title:"Upload Bukti Bayar",  desc:"Upload foto bukti transfer langsung di website, tidak perlu kirim via WA." },
  { num:"04", title:"Terima Link",         desc:"Tim kami verifikasi dan kerjakan undangan. Link dikirim ke WhatsApp kamu dalam 1×24 jam." },
];

function fmt(n) { return "Rp " + n.toLocaleString("id-ID"); }

const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Cinzel:wght@400;500&family=Cormorant+Garamond:ital,wght@0,300;1,400&family=Josefin+Sans:wght@200;300;400&display=swap');
  *, *::before, *::after { box-sizing:border-box; margin:0; padding:0; }
  html { scroll-behavior:smooth;  font-size:16px; }
  body { background:#0C0B09; color:rgba(240,232,216,.9); font-family:'Josefin Sans',sans-serif; font-weight:300; overflow-x:hidden; }

  @keyframes hpFadeUp  { from{opacity:0;transform:translateY(28px)} to{opacity:1;transform:translateY(0)} }
  @keyframes hpFadeIn  { from{opacity:0} to{opacity:1} }
  @keyframes hpFloat   { 0%,100%{transform:translateY(0)} 50%{transform:translateY(-8px)} }
  @keyframes hpShimmer { 0%,100%{opacity:.3} 50%{opacity:1} }
  @keyframes hpPulse   { 0%,100%{transform:scale(1)} 50%{transform:scale(1.04)} }

  /* ── NAVBAR ── */
  .hp-nav { position:fixed; top:0; left:0; right:0; z-index:100; padding:0 44px; height:58px; display:flex; align-items:center; justify-content:space-between; background:rgba(12,11,9,.88); backdrop-filter:blur(20px); -webkit-backdrop-filter:blur(20px); border-bottom:1px solid rgba(201,168,76,.09); }
  .hp-nav-logo { font-family:'Cinzel',serif; font-size:16px; letter-spacing:.38em; color:rgba(201,168,76,.85); cursor:pointer; }
  .hp-nav-links { display:flex; align-items:center; gap:28px; }
  .hp-nav-link  { font-size:13px; letter-spacing:.2em; color:rgba(240,232,216,.42); cursor:pointer; transition:color .2s; text-decoration:none; }
  .hp-nav-link:hover { color:rgba(240,232,216,.8); }
  .hp-nav-cta { padding:8px 22px; border:1px solid rgba(201,168,76,.4); color:rgba(201,168,76,.9); font-family:'Cinzel',serif; font-size:13px; letter-spacing:.2em; cursor:pointer; background:transparent; transition:all .25s; }
  .hp-nav-cta:hover { background:rgba(201,168,76,.1); border-color:rgba(201,168,76,.7); }
  .hp-nav-hamburger { display:none; background:none; border:none; cursor:pointer; font-size:1.3rem; color:rgba(240,232,216,.5); }

  /* ── HERO ── */
  .hp-hero { min-height:100vh; display:flex; flex-direction:column; align-items:center; justify-content:center; text-align:center; padding:120px 28px 80px; position:relative; overflow:hidden; }
  .hp-hero-glow { position:absolute; top:-20%; left:50%; transform:translateX(-50%); width:80%; height:100%; background:radial-gradient(ellipse 70% 55% at 50% 35%, rgba(201,168,76,.07), transparent 65%); pointer-events:none; }
  .hp-hero-grid { position:absolute; inset:0; background-image: repeating-linear-gradient(0deg,rgba(201,168,76,.02) 0px,rgba(201,168,76,.02) 1px,transparent 1px,transparent 70px), repeating-linear-gradient(90deg,rgba(201,168,76,.02) 0px,rgba(201,168,76,.02) 1px,transparent 1px,transparent 70px); pointer-events:none; }
  .hp-hero-tag  { font-family:'Cinzel',serif; font-size:13px; letter-spacing:.56em; color:rgba(201,168,76,.55); margin-bottom:24px; animation:hpFadeUp 1s ease both; }
  .hp-hero-title { font-family:'Cinzel',serif; font-size:clamp(2.8rem,9vw,6.4rem); line-height:.9; letter-spacing:.03em; margin-bottom:20px; animation:hpFadeUp 1.1s ease .1s both; }
  .hp-hero-title span { color:#C9A84C; font-family:'Cormorant Garamond',serif; font-style:italic; font-weight:400; }
  .hp-hero-sub  { font-family:'Cormorant Garamond',serif; font-size:clamp(1rem,2.5vw,1.3rem); font-style:italic; color:rgba(240,232,216,.4); max-width:520px; line-height:1.85; margin-bottom:44px; animation:hpFadeUp 1s ease .2s both; }
  .hp-hero-actions { display:flex; gap:12px; flex-wrap:wrap; justify-content:center; animation:hpFadeUp 1s ease .3s both; }
  .hp-btn-primary { padding:14px 40px; background:#C9A84C; color:#0C0B09; font-family:'Cinzel',serif; font-size:14px; letter-spacing:.26em; border:none; cursor:pointer; transition:opacity .2s; }
  .hp-btn-primary:hover { opacity:.88; }
  .hp-btn-ghost   { padding:13px 34px; background:transparent; border:1px solid rgba(201,168,76,.35); color:rgba(201,168,76,.85); font-family:'Cinzel',serif; font-size:14px; letter-spacing:.26em; cursor:pointer; transition:all .25s; }
  .hp-btn-ghost:hover { background:rgba(201,168,76,.08); border-color:rgba(201,168,76,.6); }
  .hp-hero-scroll { position:absolute; bottom:32px; display:flex; flex-direction:column; align-items:center; gap:8px; animation:hpFadeIn 1.5s ease 1s both; }
  .hp-hero-scroll-label { font-family:'Cinzel',serif; font-size:11px; letter-spacing:.3em; color:rgba(201,168,76,.28); }
  .hp-hero-scroll-line  { width:1px; height:44px; background:linear-gradient(to bottom,rgba(201,168,76,.5),transparent); animation:hpShimmer 2s ease infinite; }
  /* floating preview cards */
  .hp-hero-preview { position:absolute; right:5%; top:50%; transform:translateY(-50%); display:flex; flex-direction:column; gap:10px; pointer-events:none; animation:hpFadeIn 1.4s ease .5s both; }
  .hp-prev-card { width:150px; height:100px; border:1px solid rgba(255,255,255,.1); overflow:hidden; position:relative; animation:hpFloat 4s ease infinite; }
  .hp-prev-card:nth-child(2) { animation-delay:-.8s; margin-left:22px; }
  .hp-prev-card:nth-child(3) { animation-delay:-1.6s; }

  /* ── SOCIAL PROOF ── */
  .hp-proof { padding:32px 44px; display:flex; justify-content:center; gap:56px; flex-wrap:wrap; background:#080706; border-top:1px solid rgba(201,168,76,.06); border-bottom:1px solid rgba(201,168,76,.06); }
  .hp-proof-item { text-align:center; }
  .hp-proof-val { font-family:'Cinzel',serif; font-size:clamp(1.4rem,3.5vw,2rem); color:#C9A84C; line-height:1; }
  .hp-proof-lbl { font-size:12px; letter-spacing:.22em; color:rgba(240,232,216,.3); margin-top:5px; }

  /* ── SECTIONS COMMON ── */
  .hp-sec { padding:100px 44px; }
  .hp-sec-dark { padding:100px 44px; background:#080706; }
  .hp-sec-inner { max-width:1080px; margin:0 auto; }
  .hp-sec-tag   { font-family:'Cinzel',serif; font-size:12px; letter-spacing:.54em; color:rgba(201,168,76,.48); text-align:center; margin-bottom:10px; }
  .hp-sec-title { font-family:'Cinzel',serif; font-size:clamp(1.7rem,5vw,3rem); letter-spacing:.04em; text-align:center; margin-bottom:12px; line-height:1.1; }
  .hp-sec-title span { color:#C9A84C; }
  .hp-sec-sub   { font-family:'Cormorant Garamond',serif; font-style:italic; font-size:1.05rem; color:rgba(240,232,216,.32); text-align:center; margin-bottom:56px; }
  .hp-divider   { height:1px; background:linear-gradient(to right,transparent,rgba(201,168,76,.12),transparent); }

  /* ── TEMA SHOWCASE ── */
  .hp-theme-grid { display:grid; grid-template-columns:repeat(3,1fr); gap:12px; }
  .hp-theme-card { cursor:pointer; position:relative; overflow:hidden; border:1px solid rgba(255,255,255,.07); transition:border-color .3s, transform .3s, box-shadow .3s; }
  .hp-theme-card:hover { border-color:rgba(201,168,76,.45); transform:translateY(-4px); box-shadow:0 20px 60px rgba(0,0,0,.4); }
  /* thumbnail — tall enough to see mock content clearly */
  .hp-theme-thumb { height:200px; position:relative; overflow:hidden; }
  .hp-theme-thumb-bg { position:absolute; inset:0; background:linear-gradient(150deg,var(--p0) 0%,var(--p1) 50%,var(--p2) 100%); }
  .hp-theme-thumb-shine { position:absolute; top:-40%; left:-20%; width:60%; height:160%; background:linear-gradient(105deg,transparent,rgba(255,255,255,.06),transparent); pointer-events:none; }
  .hp-theme-thumb-adat { position:absolute; top:12px; left:12px; font-family:'Cinzel',serif; font-size:10px; letter-spacing:.14em; color:rgba(201,168,76,.95); padding:3px 8px; background:rgba(0,0,0,.55); border:1px solid rgba(201,168,76,.4); }
  /* mock invitation preview inside thumbnail */
  .hp-theme-mock { position:absolute; inset:0; display:flex; flex-direction:column; align-items:center; justify-content:center; gap:6px; padding:12px; }
  .hp-theme-mock-tag { font-family:'Cinzel',serif; font-size:10px; letter-spacing:.44em; color:var(--mc); opacity:.6; }
  .hp-theme-mock-rule { width:28px; height:1px; background:var(--mc); opacity:.25; }
  .hp-theme-mock-name { font-family:'Cormorant Garamond',serif; font-style:italic; font-size:1.35rem; line-height:1.1; color:var(--mc); text-align:center; text-shadow:0 2px 12px rgba(0,0,0,.5); }
  .hp-theme-mock-amp { font-size:15px; opacity:.35; color:var(--mc); }
  .hp-theme-mock-date { font-family:'Cinzel',serif; font-size:10px; letter-spacing:.26em; color:var(--mc); opacity:.45; margin-top:4px; }
  /* info row below thumbnail */
  .hp-theme-info { padding:14px 16px 16px; background:rgba(255,255,255,.025); display:flex; align-items:center; justify-content:space-between; gap:10px; }
  .hp-theme-left .hp-theme-name { font-family:'Cinzel',serif; font-size:14px; letter-spacing:.2em; color:rgba(240,232,216,.88); margin-bottom:3px; }
  .hp-theme-sub  { font-size:12px; letter-spacing:.1em; color:rgba(240,232,216,.3); }
  .hp-theme-prev { font-family:'Cinzel',serif; font-size:11px; letter-spacing:.16em; color:rgba(201,168,76,.52); text-decoration:none; transition:color .2s; white-space:nowrap; flex-shrink:0; padding:6px 12px; border:1px solid rgba(201,168,76,.18); }
  .hp-theme-prev:hover { color:rgba(201,168,76,.9); border-color:rgba(201,168,76,.45); background:rgba(201,168,76,.04); }

  /* ── HOW IT WORKS ── */
  .hp-steps { display:grid; grid-template-columns:repeat(4,1fr); gap:0; position:relative; }
  .hp-steps::before { content:''; position:absolute; top:26px; left:10%; right:10%; height:1px; background:linear-gradient(to right,transparent,rgba(201,168,76,.18),transparent); pointer-events:none; }
  .hp-step { padding:0 20px; text-align:center; }
  .hp-step-num { font-family:'Cinzel',serif; font-size:13px; letter-spacing:.36em; color:rgba(201,168,76,.55); margin-bottom:14px; position:relative; display:inline-block; }
  .hp-step-num::before { content:''; display:block; width:10px; height:10px; border:1px solid rgba(201,168,76,.45); border-radius:50%; margin:0 auto 8px; background:#080706; }
  .hp-step-title { font-family:'Cinzel',serif; font-size:14px; letter-spacing:.14em; color:rgba(240,232,216,.85); margin-bottom:9px; }
  .hp-step-desc  { font-size:13px; letter-spacing:.08em; color:rgba(240,232,216,.32); line-height:1.85; }

  /* ── PRICING ── */
  .hp-price-grid { display:grid; grid-template-columns:repeat(4,1fr); gap:10px; align-items:start; }
  .hp-price-card { border:1px solid rgba(201,168,76,.1); padding:28px 22px; position:relative; transition:border-color .25s, box-shadow .25s; }
  .hp-price-card:hover { border-color:rgba(201,168,76,.3); box-shadow:0 10px 40px rgba(0,0,0,.3); }
  .hp-price-card.popular { border-color:rgba(201,168,76,.4); }
  .hp-price-popular-badge { position:absolute; top:-1px; left:50%; transform:translateX(-50%); font-family:'Cinzel',serif; font-size:10px; letter-spacing:.18em; padding:4px 16px; background:#C9A84C; color:#0C0B09; white-space:nowrap; }
  .hp-price-name  { font-family:'Cinzel',serif; font-size:15px; letter-spacing:.24em; margin-bottom:6px; }
  .hp-price-amount{ font-family:'Cinzel',serif; font-size:clamp(1.6rem,3.5vw,2.2rem); line-height:1; margin-bottom:6px; }
  .hp-price-desc  { font-size:12px; letter-spacing:.08em; color:rgba(240,232,216,.32); margin-bottom:22px; line-height:1.75; }
  .hp-price-list  { margin-bottom:24px; }
  .hp-price-item  { display:flex; align-items:flex-start; gap:8px; padding:7px 0; border-bottom:1px solid rgba(255,255,255,.04); font-size:12px; letter-spacing:.08em; color:rgba(240,232,216,.55); }
  .hp-price-item:last-child { border-bottom:none; }
  .hp-price-check { color:rgba(201,168,76,.65); flex-shrink:0; font-size:16px; margin-top:1px; }
  .hp-price-btn   { width:100%; padding:12px; background:transparent; border:1px solid rgba(201,168,76,.25); color:rgba(201,168,76,.8); font-family:'Cinzel',serif; font-size:13px; letter-spacing:.2em; cursor:pointer; transition:all .25s; }
  .hp-price-btn:hover { background:rgba(201,168,76,.08); border-color:rgba(201,168,76,.55); }
  .hp-price-btn.primary { background:#C9A84C; color:#0C0B09; border-color:#C9A84C; }
  .hp-price-btn.primary:hover { opacity:.88; }

  /* ── FEATURES ── */
  .hp-feat-grid { display:grid; grid-template-columns:repeat(5,1fr); gap:10px; }
  .hp-feat-card { padding:22px 18px; border:1px solid rgba(201,168,76,.08); transition:border-color .25s, background .25s; }
  .hp-feat-card:hover { border-color:rgba(201,168,76,.25); background:rgba(201,168,76,.04); }
  .hp-feat-icon  { font-size:1.5rem; margin-bottom:13px; }
  .hp-feat-title { font-family:'Cinzel',serif; font-size:13px; letter-spacing:.16em; color:rgba(240,232,216,.82); margin-bottom:7px; }
  .hp-feat-desc  { font-size:12px; letter-spacing:.08em; color:rgba(240,232,216,.3); line-height:1.8; margin-bottom:12px; }
  .hp-feat-price { font-family:'Cinzel',serif; font-size:13px; color:rgba(201,168,76,.68); }

  /* ── FAQ ── */
  .hp-faq-list { max-width:720px; margin:0 auto; }
  .hp-faq-item { border-bottom:1px solid rgba(201,168,76,.08); }
  .hp-faq-q    { display:flex; justify-content:space-between; align-items:center; gap:14px; padding:20px 0; cursor:pointer; }
  .hp-faq-q-text { font-size:14px; letter-spacing:.1em; color:rgba(240,232,216,.75); line-height:1.55; }
  .hp-faq-icon { color:rgba(201,168,76,.5); font-size:17px; flex-shrink:0; transition:transform .25s; }
  .hp-faq-icon.open { transform:rotate(45deg); }
  .hp-faq-a    { font-size:13px; letter-spacing:.08em; color:rgba(240,232,216,.38); line-height:1.9; padding-bottom:18px; }

  /* ── CTA BAND ── */
  .hp-cta-band { padding:110px 44px; text-align:center; position:relative; overflow:hidden; background:linear-gradient(to bottom,#080706,#0C0B09); }
  .hp-cta-band-glow { position:absolute; inset:0; background:radial-gradient(ellipse 60% 70% at 50% 50%,rgba(201,168,76,.07),transparent 65%); pointer-events:none; }
  .hp-cta-title { font-family:'Cinzel',serif; font-size:clamp(1.7rem,5vw,3.2rem); letter-spacing:.04em; margin-bottom:12px; line-height:1.1; position:relative; }
  .hp-cta-title span { color:#C9A84C; }
  .hp-cta-sub   { font-family:'Cormorant Garamond',serif; font-style:italic; font-size:1.05rem; color:rgba(240,232,216,.3); margin-bottom:42px; position:relative; }
  .hp-cta-actions { display:flex; gap:12px; justify-content:center; flex-wrap:wrap; position:relative; }

  /* ── FOOTER ── */
  .hp-footer { padding:40px 44px; border-top:1px solid rgba(201,168,76,.07); display:grid; grid-template-columns:1fr auto; gap:28px; align-items:center; }
  .hp-footer-logo { font-family:'Cinzel',serif; font-size:15px; letter-spacing:.38em; color:rgba(201,168,76,.5); }
  .hp-footer-sub  { font-size:12px; letter-spacing:.14em; color:rgba(240,232,216,.2); margin-top:5px; }
  .hp-footer-links { display:flex; gap:24px; flex-wrap:wrap; }
  .hp-footer-link  { font-size:12px; letter-spacing:.18em; color:rgba(240,232,216,.28); cursor:pointer; text-decoration:none; transition:color .2s; }
  .hp-footer-link:hover { color:rgba(240,232,216,.65); }

  /* reveal animation */
  .hp-reveal { opacity:0; transform:translateY(24px); transition:opacity .9s ease, transform .9s ease; }
  .hp-reveal.visible { opacity:1; transform:none; }

  @media(max-width:1100px) {
    .hp-feat-grid  { grid-template-columns:repeat(3,1fr); }
  }
  @media(max-width:1024px) {
    .hp-price-grid { grid-template-columns:1fr 1fr; }
    .hp-feat-grid  { grid-template-columns:1fr 1fr; }
    .hp-hero-preview { display:none; }
    .hp-theme-grid { grid-template-columns:repeat(2,1fr); }
  }
  @media(max-width:768px) {
    .hp-nav { padding:0 20px; }
    .hp-nav-links { display:none; }
    .hp-nav-hamburger { display:block; }
    .hp-sec, .hp-sec-dark { padding:72px 20px; }
    .hp-proof { gap:28px; padding:28px 20px; }
    .hp-steps { grid-template-columns:1fr 1fr; gap:32px; }
    .hp-steps::before { display:none; }
    .hp-footer { grid-template-columns:1fr; }
  }
  @media(max-width:560px) {
    .hp-price-grid { grid-template-columns:1fr; }
    .hp-theme-grid { grid-template-columns:1fr; }
    .hp-feat-grid  { grid-template-columns:1fr 1fr; }
    .hp-steps      { grid-template-columns:1fr; }
  }
`;

function useReveal() {
  const ref = useRef();
  useEffect(() => {
    const obs = new IntersectionObserver(
      ([e]) => { if (e.isIntersecting) { e.target.classList.add("visible"); obs.unobserve(e.target); } },
      { threshold: 0.12 }
    );
    const el = ref.current;
    if (el) obs.observe(el);
    return () => obs.disconnect();
  }, []);
  return ref;
}

function Reveal({ children, delay = 0 }) {
  const ref = useReveal();
  return (
    <div ref={ref} className="hp-reveal" style={{ transitionDelay: `${delay}s` }}>
      {children}
    </div>
  );
}

// Pick mock color based on palette dark/light
function mockColor(t) {
  return t.dark ? t.palette[2] : t.palette[2];
}

export default function Homepage() {
  const navigate = useNavigate();
  const [openFaq, setOpenFaq] = useState(null);

  function goOrder(pkg) {
    navigate(pkg ? `/order?paket=${pkg}` : "/order");
  }

  return (
    <>
      <style>{CSS}</style>

      {/* ── NAVBAR ── */}
      <nav className="hp-nav">
        <div className="hp-nav-logo" onClick={() => window.scrollTo({top:0,behavior:"smooth"})}>
          ✦ MYKISAH
        </div>
        <div className="hp-nav-links">
          <a href="#tema"   className="hp-nav-link">Tema</a>
          <a href="#harga"  className="hp-nav-link">Harga</a>
          <a href="#cara"   className="hp-nav-link">Cara Pesan</a>
          <a href="#faq"    className="hp-nav-link">FAQ</a>
          <a href="/cek-order" className="hp-nav-link">Cek Order</a>
          <button className="hp-nav-cta" onClick={() => navigate("/order")}>
            Pesan Sekarang
          </button>
        </div>
        <button className="hp-nav-hamburger">☰</button>
      </nav>

      {/* ── HERO ── */}
      <section className="hp-hero">
        <div className="hp-hero-glow" />
        <div className="hp-hero-grid" />
        <div className="hp-hero-tag">✦ UNDANGAN DIGITAL PERNIKAHAN ✦</div>
        <h1 className="hp-hero-title">
          Undangan yang<br />
          <span>Layak Dikenang</span>
        </h1>
        <p className="hp-hero-sub">
          9 tema eksklusif, fitur lengkap, harga terjangkau.<br />
          Mulai dari Rp 49.000 · Selesai dalam 1×24 jam.
        </p>
        <div className="hp-hero-actions">
          <button className="hp-btn-primary" onClick={() => navigate("/order")}>
            Buat Undangan
          </button>
          <button className="hp-btn-ghost" onClick={() => navigate("/demo")}>
            Lihat Demo
          </button>
        </div>

        {/* floating preview cards */}
        <div className="hp-hero-preview">
          {[
            { palette:["#0C0B09","#1A1610","#C9A84C"], label:"Eternal", dark:true  },
            { palette:["#120608","#1A0C0A","#C97B6F"], label:"Amour",   dark:true  },
            { palette:["#F5F0E8","#EDE5D8","#8B6F47"], label:"Ivory",   dark:false },
          ].map((t,i) => (
            <div key={i} className="hp-prev-card"
              style={{background:`linear-gradient(135deg,${t.palette[0]},${t.palette[1]},${t.palette[2]})`}}>
              <div style={{ position:"absolute", inset:0, display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"center", gap:3 }}>
                <div style={{ fontFamily:"serif", fontSize:".55rem", color:t.palette[2], opacity:.9, fontStyle:"italic" }}>Ahmad & Sari</div>
                <div style={{ width:20, height:1, background:t.palette[2], opacity:.3 }} />
                <div style={{ fontFamily:"sans-serif", fontSize:".28rem", letterSpacing:".2em", color:t.palette[2], opacity:.4 }}>{t.label}</div>
              </div>
            </div>
          ))}
        </div>

        <div className="hp-hero-scroll">
          <div className="hp-hero-scroll-label">Scroll</div>
          <div className="hp-hero-scroll-line" />
        </div>
      </section>

      {/* ── SOCIAL PROOF ── */}
      <div className="hp-proof">
        {[["9","Tema Eksklusif"],["1×24 jam","Selesai Dikerjakan"],["Rp 49rb","Mulai Dari"],["100%","Web-based · Zero Install"]].map(([v,l]) => (
          <div key={l} className="hp-proof-item">
            <div className="hp-proof-val">{v}</div>
            <div className="hp-proof-lbl">{l}</div>
          </div>
        ))}
      </div>

      {/* ── TEMA ── */}
      <section id="tema" className="hp-sec">
        <div className="hp-sec-inner">
          <Reveal>
            <div className="hp-sec-tag">✦ TEMA</div>
            <h2 className="hp-sec-title">9 Tema, <span>Satu Selera</span></h2>
            <p className="hp-sec-sub">Modern, klasik, hingga adat — setiap tema punya layout yang benar-benar berbeda.</p>
          </Reveal>
          <div className="hp-theme-grid">
            {THEMES.map((t,i) => {
              const mc = mockColor(t);
              const txColor = t.dark ? "rgba(240,232,216,.85)" : "rgba(28,24,16,.85)";
              return (
                <Reveal key={t.id} delay={i*0.05}>
                  <div className="hp-theme-card"
                    style={{"--p0":t.palette[0],"--p1":t.palette[1],"--p2":t.palette[2],"--mc":mc}}
                    onClick={() => navigate(`/demo?tema=${t.id}`)}>
                    <div className="hp-theme-thumb">
                      <div className="hp-theme-thumb-bg" />
                      <div className="hp-theme-thumb-shine" />
                      {/* Decorative border overlay */}
                      <div style={{ position:"absolute", inset:12, border:`1px solid ${mc}22`, pointerEvents:"none" }} />
                      {t.adat && <span className="hp-theme-thumb-adat">ADAT</span>}
                      {/* Mock invitation preview */}
                      <div className="hp-theme-mock" style={{"--mc":mc}}>
                        <div className="hp-theme-mock-tag">✦ UNDANGAN PERNIKAHAN ✦</div>
                        <div className="hp-theme-mock-rule" />
                        <div className="hp-theme-mock-name" style={{ color:txColor }}>
                          Ahmad
                          <span className="hp-theme-mock-amp" style={{ display:"block", color:mc }}>&amp;</span>
                          <span style={{ color:mc }}>Sari</span>
                        </div>
                        <div className="hp-theme-mock-rule" />
                        <div className="hp-theme-mock-date">Sabtu, 12 Juli 2025</div>
                      </div>
                    </div>
                    <div className="hp-theme-info">
                      <div className="hp-theme-left">
                        <div className="hp-theme-name">{t.label}</div>
                        <div className="hp-theme-sub">{t.sub}</div>
                      </div>
                      <a href={`/demo?tema=${t.id}`} className="hp-theme-prev"
                        onClick={e => e.stopPropagation()}>Preview →</a>
                    </div>
                  </div>
                </Reveal>
              );
            })}
          </div>
          <Reveal>
            <div style={{ textAlign:"center", marginTop:40 }}>
              <button className="hp-btn-ghost" onClick={() => navigate("/demo")}>
                Lihat Semua Tema
              </button>
            </div>
          </Reveal>
        </div>
      </section>

      <div className="hp-divider" />

      {/* ── CARA PESAN ── */}
      <section id="cara" className="hp-sec-dark">
        <div className="hp-sec-inner">
          <Reveal>
            <div className="hp-sec-tag">✦ CARA PESAN</div>
            <h2 className="hp-sec-title">Mudah dalam <span>4 Langkah</span></h2>
            <p className="hp-sec-sub">Dari pilih tema sampai undangan aktif, semua bisa dilakukan sendiri.</p>
          </Reveal>
          <div className="hp-steps">
            {STEPS.map((s,i) => (
              <Reveal key={s.num} delay={i*0.1}>
                <div className="hp-step">
                  <div className="hp-step-num">{s.num}</div>
                  <div className="hp-step-title">{s.title}</div>
                  <div className="hp-step-desc">{s.desc}</div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <div className="hp-divider" />

      {/* ── HARGA ── */}
      <section id="harga" className="hp-sec">
        <div className="hp-sec-inner">
          <Reveal>
            <div className="hp-sec-tag">✦ HARGA</div>
            <h2 className="hp-sec-title">Transparan, <span>Tanpa Kejutan</span></h2>
            <p className="hp-sec-sub">Pilih paket bundling atau susun sendiri à la carte sesuai kebutuhan.</p>
          </Reveal>
          <div className="hp-price-grid">
            {PACKAGES.map((p,i) => (
              <Reveal key={p.id} delay={i*0.07}>
                <div className={`hp-price-card${p.popular?" popular":""}`}
                  style={{ borderTopColor: p.color, borderTopWidth:2, borderTopStyle:"solid" }}>
                  {p.popular && <div className="hp-price-popular-badge">POPULER</div>}
                  <div className="hp-price-name" style={{ color:p.color }}>{p.name}</div>
                  <div className="hp-price-amount">{fmt(p.price)}</div>
                  <div className="hp-price-desc">{p.desc}</div>
                  <div className="hp-price-list">
                    {p.includes.map(item => (
                      <div key={item} className="hp-price-item">
                        <span className="hp-price-check">✦</span>
                        {item}
                      </div>
                    ))}
                  </div>
                  <button
                    className={`hp-price-btn${p.popular?" primary":""}`}
                    style={!p.popular ? { borderColor:p.color+"55", color:p.color } : {}}
                    onClick={() => goOrder(p.id)}>
                    {p.cta}
                  </button>
                </div>
              </Reveal>
            ))}
          </div>
          <Reveal>
            <div style={{ textAlign:"center", marginTop:32,
                          fontFamily:"'Cormorant Garamond',serif", fontStyle:"italic",
                          fontSize:"1rem", color:"rgba(240,232,216,.28)" }}>
              Atau pilih add-on satuan sesuai kebutuhan saat checkout.
            </div>
          </Reveal>
        </div>
      </section>

      <div className="hp-divider" />

      {/* ── FEATURES / ADD-ONS ── */}
      <section className="hp-sec-dark">
        <div className="hp-sec-inner">
          <Reveal>
            <div className="hp-sec-tag">✦ ADD-ON</div>
            <h2 className="hp-sec-title">Susun Sesuai <span>Kebutuhanmu</span></h2>
            <p className="hp-sec-sub">Semua add-on bisa dipilih satuan saat checkout. Bayar apa yang kamu butuhkan saja.</p>
          </Reveal>
          <div className="hp-feat-grid">
            {FEATURES.map((f,i) => (
              <Reveal key={f.title} delay={i*0.04}>
                <div className="hp-feat-card">
                  <div className="hp-feat-icon">{f.icon}</div>
                  <div className="hp-feat-title">{f.title}</div>
                  <div className="hp-feat-desc">{f.desc}</div>
                  <div className="hp-feat-price">{f.price}</div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <div className="hp-divider" />

      {/* ── FAQ ── */}
      <section id="faq" className="hp-sec">
        <div className="hp-sec-inner">
          <Reveal>
            <div className="hp-sec-tag">✦ FAQ</div>
            <h2 className="hp-sec-title">Pertanyaan yang <span>Sering Ditanya</span></h2>
          </Reveal>
          <div className="hp-faq-list">
            {FAQS.map((faq,i) => (
              <Reveal key={i} delay={i*0.04}>
                <div className="hp-faq-item">
                  <div className="hp-faq-q" onClick={() => setOpenFaq(openFaq===i?null:i)}>
                    <span className="hp-faq-q-text">{faq.q}</span>
                    <span className={`hp-faq-icon${openFaq===i?" open":""}`}>+</span>
                  </div>
                  {openFaq===i && <div className="hp-faq-a">{faq.a}</div>}
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      {/* ── CTA BAND ── */}
      <div className="hp-cta-band">
        <div className="hp-cta-band-glow" />
        <Reveal>
          <h2 className="hp-cta-title">
            Siap Buat<br/><span>Undanganmu?</span>
          </h2>
          <p className="hp-cta-sub">Mulai dari Rp 49.000 · Selesai dalam 1×24 jam kerja.</p>
          <div className="hp-cta-actions">
            <button className="hp-btn-primary" onClick={() => navigate("/order")}>
              Buat Undangan Sekarang
            </button>
            <button className="hp-btn-ghost" onClick={() => navigate("/demo")}>
              Lihat Demo Dulu
            </button>
          </div>
        </Reveal>
      </div>

      {/* ── FOOTER ── */}
      <footer className="hp-footer">
        <div>
          <div className="hp-footer-logo">✦ MYKISAH</div>
          <div className="hp-footer-sub">Undangan digital yang layak dikenang.</div>
        </div>
        <div className="hp-footer-links">
          <a href="/demo"      className="hp-footer-link">Demo</a>
          <a href="/order"     className="hp-footer-link">Pesan</a>
          <a href="/cek-order" className="hp-footer-link">Cek Order</a>
          <a href="/reseller"  className="hp-footer-link">Reseller</a>
        </div>
      </footer>
    </>
  );
}
